"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetProvider = exports.WidgetConfigContext = exports.WidgetContext = void 0;
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const interface_1 = require("../interface");
const error_handler_1 = require("../error_handler");
const lodash_1 = require("lodash");
const components_1 = require("@apitable/components");
const _Provider = react_redux_1.Provider;
/**
 * 1. provide the ability to read and write to the data source of the widget.
 * 2. provide the ability to read and write to the datasheet data.
 */
exports.WidgetContext = react_1.default.createContext(null);
/**
 * Provide the ability to get and control the outer UI state of the widget.
 */
exports.WidgetConfigContext = react_1.default.createContext(null);
/**
 * Within the main project, the WidgetProvider need to be wrapped before the widget be used.
 */
const WidgetProvider = props => {
    const { id, className, style, locale = 'zh-CN', theme = components_1.ThemeName.Light, runtimeEnv = interface_1.RuntimeEnv.Desktop, isShowingSettings, isFullscreen, toggleSettings, toggleFullscreen, expandRecord, children } = props;
    const [widgetStore, setWidgetStore] = (0, react_1.useState)();
    const [mountId] = (0, react_1.useState)(() => id + (0, lodash_1.uniqueId)());
    const [datasheetId, setDatasheetId] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        var _a;
        if (props.widgetStore) {
            setWidgetStore(props.widgetStore);
            setDatasheetId((_a = props.widgetStore.getState().widget) === null || _a === void 0 ? void 0 : _a.snapshot.datasheetId);
            return;
        }
    }, [id, props.widgetStore]);
    const widgetConfigValue = (0, react_1.useMemo)(() => {
        return { mountId, isShowingSettings, isFullscreen, toggleFullscreen, toggleSettings, expandRecord };
    }, [mountId, isShowingSettings, isFullscreen, toggleFullscreen, expandRecord, toggleSettings]);
    const widgetContextValue = (0, react_1.useMemo)(() => {
        return { id, locale, theme, datasheetId, widgetStore, runtimeEnv };
    }, [id, locale, theme, datasheetId, widgetStore, runtimeEnv]);
    if (!widgetStore) {
        return null;
    }
    return (react_1.default.createElement(_Provider, { store: widgetStore },
        react_1.default.createElement(exports.WidgetContext.Provider, { value: widgetContextValue },
            react_1.default.createElement(exports.WidgetConfigContext.Provider, { value: widgetConfigValue },
                react_1.default.createElement("div", { className: className, style: Object.assign({ height: '100%', width: '100%' }, style) },
                    react_1.default.createElement(error_handler_1.ErrorHandler, null, children))))));
};
exports.WidgetProvider = WidgetProvider;
